import { Button } from "@/overlay/components/CommonParts/buttons";
import Illustration from "@/style/img/illustration_not_found_page.svg";
import { Trans } from "@lingui/react/macro";
import styles from "./not-found-style.module.scss";

export interface NotFoundPageProps {
  description: string;
  firstTabId?: number;
}

export default function NotFoundPage(props: NotFoundPageProps) {
  const redirectToFirstTab = () => {
    const url = window.location.href;
    const newUrl = url.replace(/\/\d+$/, `/${props.firstTabId}`);
    window.location.assign(newUrl);
  };

  return (
    <div className={styles["page-not-found"]}>
      <div className={styles.wrap}>
        <div className={styles.content}>
          <div className={styles["card-wrap"]} aria-labelledby="title">
            <div className={styles.card}>
              <h1 id="title">
                <Trans>Oops! We couldn’t find this page.</Trans>
              </h1>
              <p className={styles.lead}>{props.description}</p>

              <div className={styles.actions}>
                {props.firstTabId !== undefined && (
                  <Button active={true} onClick={redirectToFirstTab}>
                    <Trans>Go to dashboards first tab</Trans>
                  </Button>
                )}
                <Button onClick={() => window.location.assign("/")}>
                  <Trans>Go to home page</Trans>
                </Button>
              </div>
            </div>
          </div>

          <div className={styles.illo} aria-hidden="true">
            <img src={Illustration} alt="Icon" />
          </div>
        </div>
      </div>

      <footer>
        Copyright © 2025 Meteomatics AG
        <span className={styles.dot}>•</span>
        <a href="https://www.meteomatics.com/en/imprint/">Imprint</a>
        <span className={styles.dot}>•</span>
        <a href="https://www.meteomatics.com/en/privacy-policy/">Privacy Policy</a>
      </footer>
    </div>
  );
}
